import { render } from "./SectionWhy.vue?vue&type=template&id=4578e364"
import script from "./SectionWhy.vue?vue&type=script&lang=js"
export * from "./SectionWhy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__